var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c_popup"},[_c('div',{staticClass:"van-overlay",staticStyle:{"z-index":"9"}}),_c('div',{staticClass:"van-popup van-popup--bottom",staticStyle:{"z-index":"10"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }